(function () {
  'use strict';

  var PAGE_SENSE_SRC = 'https://cdn.pagesense.io/js/901775231/bdd5f1a639d946b3a42de0d1928009d4.js';
  var previousPermissions = null;
  var reloadScheduled = false;

  function loadScriptOnce(id, src) {
    var script;
    if (document.getElementById(id)) return;
    script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.setAttribute('data-kjs-consent-controlled', 'true');
    document.head.appendChild(script);
  }

  function readPermissions() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return null;
    return {
      analytics: privacy.analyticsProcessingAllowed(),
      marketing: privacy.marketingAllowed(),
      preferences: privacy.preferencesProcessingAllowed(),
      saleOfData: privacy.saleOfDataAllowed()
    };
  }

  function applyPermissions(next) {
    var analyticsWithdrawn;
    if (!next) return;

    analyticsWithdrawn = previousPermissions && previousPermissions.analytics && !next.analytics;
    if (analyticsWithdrawn && document.getElementById('kjs-pagesense')) {
      if (!reloadScheduled) {
        reloadScheduled = true;
        window.setTimeout(function () { window.location.reload(); }, 100);
      }
      return;
    }

    if (next.analytics) {
      loadScriptOnce('kjs-pagesense', PAGE_SENSE_SRC);
    }
    previousPermissions = next;
    document.documentElement.setAttribute('data-kjs-analytics-allowed', next.analytics ? 'true' : 'false');
    document.documentElement.setAttribute('data-kjs-marketing-allowed', next.marketing ? 'true' : 'false');
    document.documentElement.setAttribute('data-kjs-preferences-allowed', next.preferences ? 'true' : 'false');
    document.documentElement.setAttribute('data-kjs-sale-of-data-allowed', next.saleOfData ? 'true' : 'false');
  }

  function initializeConsentControlledScripts() {
    applyPermissions(readPermissions());
    document.addEventListener('visitorConsentCollected', function () {
      applyPermissions(readPermissions());
    });
  }

  function startConsentControls() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function (error) {
      if (error) return;
      initializeConsentControlledScripts();
    });
  }

  function setStatus(message) {
    var status = document.querySelector('[data-kjs-privacy-status]');
    if (status) status.textContent = message || '';
  }

  function openCookiePreferences(button) {
    var attempt = 0;
    var maximumAttempts = 20;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    setStatus('');

    function tryOpen() {
      var result;
      attempt += 1;
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        try {
          result = window.privacyBanner.showPreferences();
          Promise.resolve(result).then(function () {
            button.removeAttribute('aria-busy');
            button.disabled = false;
          }).catch(function () {
            button.removeAttribute('aria-busy');
            button.disabled = false;
            setStatus('Cookie preferences could not be opened. Please refresh the page and try again.');
          });
        } catch (error) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          setStatus('Cookie preferences could not be opened. Please refresh the page and try again.');
        }
        return;
      }

      if (attempt < maximumAttempts) {
        window.setTimeout(tryOpen, 150);
      } else {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        setStatus('Cookie preferences could not be opened. Please refresh the page and try again.');
      }
    }

    tryOpen();
  }

  function bindCookiePreferences() {
    var buttons = document.querySelectorAll('[data-kjs-cookie-preferences]');
    Array.prototype.forEach.call(buttons, function (button) {
      if (button.getAttribute('data-kjs-bound') === 'true') return;
      button.setAttribute('data-kjs-bound', 'true');
      button.addEventListener('click', function () { openCookiePreferences(button); });
    });
  }

  function initializePhase7() {
    bindCookiePreferences();
    startConsentControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePhase7);
  } else {
    initializePhase7();
  }

  document.addEventListener('shopify:section:load', bindCookiePreferences);
}());

(function () {
  'use strict';

  var API_VERSION = '2026-07';
  var RECEIVE_METHOD_KEY = 'kjs-receive-method';
  var MUTATION = [
    'mutation SetDeliveryPreference($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {',
    '  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {',
    '    cart {',
    '      checkoutUrl',
    '      buyerIdentity { preferences { delivery { deliveryMethod pickupHandle } } }',
    '    }',
    '    userErrors { code field message }',
    '    warnings { code message target }',
    '  }',
    '}'
  ].join('\n');

  function receiveMethodName(method) {
    return method === 'PICK_UP' || method === 'pickup' ? 'pickup' : 'delivery';
  }

  function readStoredReceiveMethod() {
    var method;

    try {
      method = window.sessionStorage.getItem(RECEIVE_METHOD_KEY);
    } catch (storageError) {
      return '';
    }

    return method === 'pickup' || method === 'delivery' ? method : '';
  }

  function reflectReceiveMethod(method) {
    var cards = document.querySelectorAll('[data-kjs-receive-card]');
    var index;
    var card;
    var pickupOption;
    var deliveryOption;
    var pickupAction;
    var deliveryAction;

    if (method !== 'pickup' && method !== 'delivery') return;

    for (index = 0; index < cards.length; index += 1) {
      card = cards[index];
      card.setAttribute('data-kjs-receive-method', method);
      pickupOption = card.querySelector('.kjs-receive-option:not(.kjs-receive-option--delivery)');
      deliveryOption = card.querySelector('.kjs-receive-option--delivery');
      pickupAction = card.querySelector('.kjs-pickup-checkout');
      deliveryAction = card.querySelector('.kjs-delivery-checkout, .kjs-cart-location-action');

      if (pickupOption) pickupOption.classList.toggle('is-selected', method === 'pickup');
      if (deliveryOption) deliveryOption.classList.toggle('is-selected', method === 'delivery');

      if (pickupAction && deliveryAction && !card.classList.contains('kjs-v7-receive-card')) {
        pickupAction.classList.toggle('kjs-option-button--primary', method === 'pickup');
        pickupAction.classList.toggle('kjs-option-button--secondary', method !== 'pickup');
        deliveryAction.classList.toggle('kjs-option-button--primary', method === 'delivery');
        deliveryAction.classList.toggle('kjs-option-button--secondary', method !== 'delivery');
      }
    }
  }

  function rememberReceiveMethod(method) {
    method = receiveMethodName(method);

    try {
      window.sessionStorage.setItem(RECEIVE_METHOD_KEY, method);
    } catch (storageError) {
      /* The checkout still works when session storage is unavailable. */
    }

    reflectReceiveMethod(method);
  }

  function resetRestoredCheckoutButtons() {
    var buttons = document.querySelectorAll('.kjs-pickup-checkout, .kjs-delivery-checkout');
    var index;

    for (index = 0; index < buttons.length; index += 1) {
      setBusy(buttons[index], false);
      buttons[index].removeAttribute('data-kjs-preference-bypass');
    }
  }

  function restoreCartReceiveState() {
    resetRestoredCheckoutButtons();
    reflectReceiveMethod(readStoredReceiveMethod());
  }

  function rootUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function storefrontApiUrl() {
    var shop = window.Shopify && Shopify.shop ? Shopify.shop : '';

    if (/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop)) {
      return 'https://' + shop + '/api/' + API_VERSION + '/graphql.json';
    }

    return window.location.origin + rootUrl('api/' + API_VERSION + '/graphql.json');
  }

  function findCheckoutButton(node) {
    while (node && node !== document) {
      if (node.classList && (node.classList.contains('kjs-pickup-checkout') || node.classList.contains('kjs-delivery-checkout'))) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function showTermsError(form) {
    var checkbox = form && form.querySelector('.terms_and_conditions_wrapper input[type="checkbox"]');
    var error = form && form.querySelector('.terms_and_conditions_wrapper .error_text');

    if (checkbox && !checkbox.checked) {
      if (error) error.style.display = 'block';
      checkbox.focus();
      return true;
    }

    if (error) error.style.display = 'none';
    return false;
  }

  function errorRegion(button) {
    var container = button.closest('.kjs-receive-card, .checkout_row, .cart_btn');
    return container && container.querySelector('[data-kjs-pickup-error]');
  }

  function setBusy(button, busy) {
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
    }
  }

  function removeShipSketchHelper(button) {
    var encodedKey = button.getAttribute('data-shipsketch-key') || '';
    var helperKey = encodedKey;

    if (!encodedKey) return Promise.resolve();

    try {
      helperKey = decodeURIComponent(encodedKey);
    } catch (decodeError) {
      helperKey = encodedKey;
    }

    function clearStaleKeys() {
      var buttons = document.querySelectorAll('.kjs-pickup-checkout[data-shipsketch-key]');
      var index;
      var currentKey;

      for (index = 0; index < buttons.length; index += 1) {
        currentKey = buttons[index].getAttribute('data-shipsketch-key') || '';
        try {
          currentKey = decodeURIComponent(currentKey);
        } catch (keyDecodeError) {
          /* Keep the original key when it is not URI encoded. */
        }
        if (currentKey === helperKey) buttons[index].setAttribute('data-shipsketch-key', '');
      }
    }

    function helperExistsInCart(cart) {
      var items = cart && cart.items ? cart.items : [];
      var index;

      for (index = 0; index < items.length; index += 1) {
        if (items[index].key === helperKey) return true;
      }
      return false;
    }

    return window.fetch(rootUrl('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to check the current delivery location.');
      return response.json();
    }).then(function (cart) {
      if (!helperExistsInCart(cart)) {
        clearStaleKeys();
        return;
      }

      return window.fetch(rootUrl('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: helperKey, quantity: 0 })
      }).then(function (response) {
        if (response.ok) {
          clearStaleKeys();
          return;
        }

        /* The helper can disappear between the cart check and removal request. */
        return window.fetch(rootUrl('cart.js'), {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        }).then(function (verificationResponse) {
          if (!verificationResponse.ok) throw new Error('Unable to remove the delivery location helper.');
          return verificationResponse.json();
        }).then(function (latestCart) {
          if (helperExistsInCart(latestCart)) throw new Error('Unable to remove the delivery location helper.');
          clearStaleKeys();
        });
      });
    });
  }

  function waitForCartActions() {
    return new Promise(function (resolve, reject) {
      var attempts = 0;

      function check() {
        if (window.Shopify && Shopify.actions && typeof Shopify.actions.getCart === 'function') {
          resolve(Shopify.actions);
          return;
        }

        attempts += 1;
        if (attempts >= 50) {
          reject(new Error('Cart actions are unavailable.'));
          return;
        }
        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function requestPreference(method) {
    return waitForCartActions().then(function (actions) {
      return actions.getCart();
    }).then(function (result) {
      var cart = result && result.cart;
      var controller;
      var timeout;

      if (!cart || !cart.id) throw new Error('No active cart was found.');

      controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 7000);

      return window.fetch(storefrontApiUrl(), {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        signal: controller ? controller.signal : undefined,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          query: MUTATION,
          variables: {
            cartId: cart.id,
            buyerIdentity: {
              preferences: {
                delivery: { deliveryMethod: [method] }
              }
            }
          }
        })
      }).finally(function () {
        window.clearTimeout(timeout);
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('The checkout preference request failed.');
      return response.json();
    }).then(function (result) {
      var payload;
      var delivery;
      var deliveryMethods;

      if (result.errors && result.errors.length) throw new Error(result.errors[0].message || 'The checkout preference was rejected.');

      payload = result.data && result.data.cartBuyerIdentityUpdate;
      if (payload && payload.userErrors && payload.userErrors.length) {
        throw new Error(payload.userErrors[0].message || 'The checkout preference was rejected.');
      }
      if (!payload || !payload.cart || !payload.cart.checkoutUrl) throw new Error('The checkout URL was unavailable.');

      delivery = payload.cart.buyerIdentity && payload.cart.buyerIdentity.preferences && payload.cart.buyerIdentity.preferences.delivery;
      deliveryMethods = delivery && delivery.deliveryMethod ? delivery.deliveryMethod : [];
      if (deliveryMethods.indexOf(method) === -1) throw new Error('Shopify did not save the requested checkout preference.');

      return payload.cart.checkoutUrl;
    });
  }

  function resumeDeliveryCheckout(button) {
    setBusy(button, false);
    button.setAttribute('data-kjs-preference-bypass', 'true');
    window.setTimeout(function () {
      button.click();
    }, 0);
  }

  function continueToCheckout(button, method) {
    var region = errorRegion(button);
    var preparation = method === 'PICK_UP' ? removeShipSketchHelper(button) : Promise.resolve();

    setBusy(button, true);
    if (region) {
      region.hidden = true;
      region.textContent = '';
    }

    preparation.then(function () {
      return requestPreference(method);
    }).then(function (checkoutUrl) {
      if (method === 'SHIPPING') {
        /* Let the existing form and ShipSketch validation finish the delivery flow. */
        resumeDeliveryCheckout(button);
        return;
      }
      window.location.assign(checkoutUrl);
    }).catch(function (error) {
      if (method === 'SHIPPING') {
        /* Preference is optional; preserve the original validated delivery flow. */
        resumeDeliveryCheckout(button);
        return;
      }

      setBusy(button, false);
      if (region) {
        region.hidden = false;
        region.textContent = 'We could not prepare pickup checkout. Please try again.';
      }
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('Pickup checkout could not be prepared.', error);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var locationAction = event.target && event.target.closest ? event.target.closest('.kjs-cart-location-action') : null;
    var button = findCheckoutButton(event.target);
    var form;
    var method;

    if (locationAction) {
      rememberReceiveMethod('SHIPPING');
      return;
    }

    if (!button) return;

    if (button.getAttribute('data-kjs-preference-bypass') === 'true') {
      button.removeAttribute('data-kjs-preference-bypass');
      return;
    }

    if (button.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    form = button.closest('form');
    if (showTermsError(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    method = button.classList.contains('kjs-pickup-checkout') ? 'PICK_UP' : 'SHIPPING';
    rememberReceiveMethod(method);

    if (method === 'SHIPPING') {
      /* Keep the customer's original trusted click intact so ShipSketch can
         intercept it and open its delivery-location prompt. Saving Shopify's
         delivery preference is useful, but it must not delay or replay the
         click that ShipSketch listens for. */
      requestPreference(method).catch(function (error) {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('Delivery preference could not be saved before ShipSketch opened.', error);
        }
      });
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    continueToCheckout(button, method);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCartReceiveState);
  } else {
    restoreCartReceiveState();
  }

  window.addEventListener('pageshow', restoreCartReceiveState);
}());

(function () {
  'use strict';

  var enhanceScheduled = false;
  var RECEIVE_METHOD_KEY = 'kjs-receive-method';
  var DRAWER_CART_SELECTOR = '.mfp-wrap .modal-popup > .cart_menu';
  var FULL_CART_ROW_SELECTOR = 'body.template-cart #KjsCartForm .con_row > ul';
  var CART_MUTATION_SELECTOR = DRAWER_CART_SELECTOR + ', body.template-cart #KjsCartForm';

  function readStoredReceiveMethod() {
    var method;

    try {
      method = window.sessionStorage.getItem(RECEIVE_METHOD_KEY);
    } catch (storageError) {
      return '';
    }

    return method === 'pickup' || method === 'delivery' ? method : '';
  }

  function rememberReceiveMethod(method) {
    try {
      window.sessionStorage.setItem(RECEIVE_METHOD_KEY, method);
    } catch (storageError) {
      /* The cart remains usable when session storage is unavailable. */
    }
  }

  function cartRootUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function itemTitle(row) {
    var link = row.querySelector('.item-name, li:nth-child(2) h5 a');
    var rawTitle;
    var match;

    if (!link) return 'this item';

    link.classList.add('item-name');
    rawTitle = link.textContent.replace(/^\s+|\s+$/g, '');
    match = rawTitle.match(/^(.*\S)\s+-\s+([A-Z0-9][A-Z0-9#./_-]{1,19})$/i);

    if (!match) return rawTitle;

    link.textContent = match[1];
    return match[1];
  }

  function enhanceLineItem(row) {
    var cells;
    var copyCell;
    var priceCell;
    var actionCell;
    var totalCell;
    var removeButton;
    var minusButton;
    var plusButton;
    var quantityInput;
    var error;
    var stepper;
    var title;
    var icon;
    var isFullPage;

    if (row.getAttribute('data-kjs-v7-line-item') === 'true') return;

    cells = row.children;
    removeButton = row.querySelector('.remove_item_button');
    quantityInput = row.querySelector('.number_val_input');
    minusButton = row.querySelector('.minus_btn');
    plusButton = row.querySelector('.plus_btn');

    if (cells.length < 5 || !removeButton || !quantityInput || !minusButton || !plusButton) return;

    copyCell = cells[1];
    priceCell = cells[2];
    actionCell = cells[3];
    totalCell = cells[4];
    error = actionCell.querySelector('.ajaxcart__errors');
    isFullPage = Boolean(row.closest('#KjsCartForm'));
    title = itemTitle(row);

    row.classList.add('kjs-line-item');
    if (isFullPage) row.classList.add('kjs-full-line-item');
    copyCell.classList.add('kjs-item-copy');
    priceCell.classList.add('kjs-item-price');
    actionCell.classList.add('kjs-item-actions');
    totalCell.classList.add('kjs-item-line-total');

    if (!removeButton.querySelector('.fa')) {
      icon = document.createElement('i');
      icon.className = 'fa fa-trash-o';
      icon.setAttribute('aria-hidden', 'true');
      removeButton.insertBefore(icon, removeButton.firstChild);
    }
    removeButton.setAttribute('aria-label', 'Remove ' + title + ' from cart');

    stepper = document.createElement('div');
    stepper.className = 'kjs-stepper';
    stepper.setAttribute('role', 'group');
    stepper.setAttribute('aria-label', 'Quantity for ' + title);

    if (minusButton.tagName.toLowerCase() === 'a') {
      minusButton.setAttribute('href', '#');
      minusButton.setAttribute('role', 'button');
    }
    if (plusButton.tagName.toLowerCase() === 'a') {
      plusButton.setAttribute('href', '#');
      plusButton.setAttribute('role', 'button');
    }

    minusButton.setAttribute('aria-label', 'Decrease quantity for ' + title);
    plusButton.setAttribute('aria-label', 'Increase quantity for ' + title);
    quantityInput.setAttribute('aria-label', 'Quantity for ' + title);

    stepper.appendChild(minusButton);
    stepper.appendChild(quantityInput);
    stepper.appendChild(plusButton);

    if (!isFullPage) actionCell.insertBefore(removeButton, actionCell.firstChild);
    if (error) {
      actionCell.insertBefore(stepper, error);
      error.setAttribute('role', 'status');
      error.setAttribute('aria-live', 'polite');
    } else {
      actionCell.appendChild(stepper);
    }

    row.setAttribute('data-kjs-v7-line-item', 'true');
  }

  function enhanceOrderNotes(form) {
    var notes = form.querySelector('.order_notes');
    var textarea;
    var toggle;

    if (!notes || notes.getAttribute('data-kjs-v7-note') === 'true') return;

    textarea = notes.querySelector('textarea');
    if (!textarea) return;

    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'kjs-note-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', textarea.id);
    toggle.innerHTML = '<span class="kjs-note-toggle__label"><i class="fa fa-comment-o" aria-hidden="true"></i><span>Add an order note</span></span><i class="fa fa-chevron-down kjs-note-toggle__chevron" aria-hidden="true"></i>';

    textarea.hidden = true;
    textarea.placeholder = 'Add delivery or order instructions';
    notes.classList.add('kjs-note-area');
    notes.insertBefore(toggle, textarea);
    notes.setAttribute('data-kjs-v7-note', 'true');
  }

  function setReceiveMethod(form, method) {
    var summary = form.querySelector('.kjs-v7-cart-summary');
    var card = form.querySelector('[data-kjs-receive-card]');
    var choices;
    var pickupAction;
    var deliveryActions;
    var changeLocation;
    var hint;
    var index;

    if (!summary || !card) return;

    method = method === 'delivery' ? 'delivery' : 'pickup';
    rememberReceiveMethod(method);
    form.setAttribute('data-kjs-receive-method', method);

    choices = card.querySelectorAll('[data-kjs-method]');
    for (index = 0; index < choices.length; index += 1) {
      choices[index].setAttribute('aria-pressed', choices[index].getAttribute('data-kjs-method') === method ? 'true' : 'false');
    }

    pickupAction = summary.querySelector('.kjs-pickup-checkout');
    deliveryActions = summary.querySelectorAll('.kjs-delivery-checkout, .kjs-cart-location-action');
    changeLocation = summary.querySelector('.kjs-option-text-link');
    hint = card.querySelector('[data-kjs-method-hint]');

    if (pickupAction) pickupAction.hidden = method !== 'pickup';
    for (index = 0; index < deliveryActions.length; index += 1) {
      deliveryActions[index].hidden = method !== 'delivery';
    }
    if (changeLocation) changeLocation.hidden = method !== 'delivery';

    if (hint) {
      hint.textContent = method === 'delivery'
        ? 'Mark your delivery location before continuing to checkout.'
        : 'Choose your pickup store during checkout.';
    }
  }

  function enhanceReceiveCard(card) {
    var form;
    var pickupOption;
    var deliveryOption;
    var pickupAction;
    var deliveryAction;
    var changeLocation;
    var error;
    var choices;
    var pickupChoice;
    var deliveryChoice;
    var hint;
    var summary;
    var previousSummary;
    var subtotal;
    var actions;
    var viewCart;
    var selectedMethod;
    var deliveryStatus;

    if (card.getAttribute('data-kjs-v7-receive') === 'true') return;

    form = card.closest('form');
    if (!form) return;

    pickupOption = card.querySelector('.kjs-receive-option:not(.kjs-receive-option--delivery)');
    deliveryOption = card.querySelector('.kjs-receive-option--delivery');
    pickupAction = card.querySelector('.kjs-pickup-checkout');
    deliveryAction = card.querySelector('.kjs-delivery-checkout, .kjs-cart-location-action');
    changeLocation = card.querySelector('.kjs-option-text-link');
    error = card.querySelector('[data-kjs-pickup-error]');
    subtotal = form.querySelector('.total_row');

    if (!pickupOption || !deliveryOption || !pickupAction || !deliveryAction || !subtotal) return;

    deliveryStatus = deliveryOption.classList.contains('is-selected') ? 'Location selected' : 'Choose a map location';
    selectedMethod = readStoredReceiveMethod() || (deliveryOption.classList.contains('is-selected') ? 'delivery' : 'pickup');

    choices = document.createElement('div');
    choices.className = 'kjs-method-options';

    pickupChoice = document.createElement('button');
    pickupChoice.type = 'button';
    pickupChoice.className = 'kjs-method-choice';
    pickupChoice.setAttribute('data-kjs-method', 'pickup');
    pickupChoice.innerHTML = '<i class="fa fa-home" aria-hidden="true"></i><span><strong>Store pickup</strong><small>Green Hill or Oistins</small></span>';

    deliveryChoice = document.createElement('button');
    deliveryChoice.type = 'button';
    deliveryChoice.className = 'kjs-method-choice';
    deliveryChoice.setAttribute('data-kjs-method', 'delivery');
    deliveryChoice.innerHTML = '<i class="fa fa-map-marker" aria-hidden="true"></i><span><strong>Delivery</strong><small>' + deliveryStatus + '</small></span>';

    choices.appendChild(pickupChoice);
    choices.appendChild(deliveryChoice);
    card.appendChild(choices);

    hint = document.createElement('p');
    hint.className = 'kjs-method-hint';
    hint.setAttribute('data-kjs-method-hint', '');
    card.appendChild(hint);

    previousSummary = form.querySelector('.kjs-v7-cart-summary');
    if (subtotal.parentNode) subtotal.parentNode.removeChild(subtotal);
    if (previousSummary && previousSummary.parentNode) previousSummary.parentNode.removeChild(previousSummary);

    summary = document.createElement('footer');
    summary.className = 'kjs-v7-cart-summary cart_btn';
    summary.setAttribute('aria-label', 'Cart subtotal and next step');
    summary.appendChild(subtotal);

    actions = document.createElement('div');
    actions.className = 'kjs-summary-actions';
    actions.appendChild(pickupAction);
    actions.appendChild(deliveryAction);
    if (changeLocation) actions.appendChild(changeLocation);
    summary.appendChild(actions);

    if (error) summary.appendChild(error);

    viewCart = document.createElement('a');
    viewCart.className = 'kjs-view-cart';
    viewCart.href = cartRootUrl('cart');
    viewCart.textContent = 'View full cart';
    summary.appendChild(viewCart);
    form.appendChild(summary);

    card.classList.add('kjs-v7-receive-card');
    card.setAttribute('data-kjs-v7-receive', 'true');
    setReceiveMethod(form, selectedMethod);
  }

  function enhanceCartMenu(menu) {
    var rows = menu.querySelectorAll('.cart_row > ul');
    var forms = menu.querySelectorAll('form');
    var cards = menu.querySelectorAll('[data-kjs-receive-card]');
    var index;

    for (index = 0; index < rows.length; index += 1) enhanceLineItem(rows[index]);
    for (index = 0; index < forms.length; index += 1) enhanceOrderNotes(forms[index]);
    for (index = 0; index < cards.length; index += 1) enhanceReceiveCard(cards[index]);
  }

  function enhanceAllCarts() {
    var menus = document.querySelectorAll(DRAWER_CART_SELECTOR);
    var fullCartRows = document.querySelectorAll(FULL_CART_ROW_SELECTOR);
    var index;
    enhanceScheduled = false;
    for (index = 0; index < menus.length; index += 1) enhanceCartMenu(menus[index]);
    for (index = 0; index < fullCartRows.length; index += 1) enhanceLineItem(fullCartRows[index]);
  }

  function scheduleEnhancement() {
    if (enhanceScheduled) return;
    enhanceScheduled = true;
    window.setTimeout(enhanceAllCarts, 0);
  }

  function restoreReceiveMethods() {
    var method = readStoredReceiveMethod();
    var forms;
    var index;

    enhanceAllCarts();
    if (!method) return;

    forms = document.querySelectorAll(DRAWER_CART_SELECTOR + ' form');
    for (index = 0; index < forms.length; index += 1) {
      if (forms[index].querySelector('.kjs-v7-cart-summary')) {
        setReceiveMethod(forms[index], method);
      }
    }
  }

  function isCartMutation(mutation) {
    var target = mutation.target;
    var index;
    var node;

    if (target && target.nodeType === 1 && (target.matches(CART_MUTATION_SELECTOR) || target.closest(CART_MUTATION_SELECTOR))) return true;

    for (index = 0; index < mutation.addedNodes.length; index += 1) {
      node = mutation.addedNodes[index];
      if (node.nodeType !== 1) continue;
      if (node.matches(CART_MUTATION_SELECTOR) || node.querySelector(CART_MUTATION_SELECTOR) || node.closest(CART_MUTATION_SELECTOR)) return true;
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var noteToggle = event.target.closest('.kjs-note-toggle');
    var methodChoice = event.target.closest('[data-kjs-method]');
    var form;
    var method;
    var locationAction;
    var textarea;
    var expanded;

    if (noteToggle) {
      textarea = document.getElementById(noteToggle.getAttribute('aria-controls'));
      expanded = noteToggle.getAttribute('aria-expanded') === 'true';
      noteToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (textarea) {
        textarea.hidden = expanded;
        if (!expanded) textarea.focus();
      }
      return;
    }

    if (methodChoice) {
      form = methodChoice.closest('form');
      method = methodChoice.getAttribute('data-kjs-method');
      setReceiveMethod(form, method);

      if (method === 'delivery' && methodChoice.closest(DRAWER_CART_SELECTOR)) {
        locationAction = form && form.querySelector('.kjs-v7-cart-summary .kjs-cart-location-action:not([hidden])');
        if (locationAction && locationAction.href) {
          event.preventDefault();
          window.location.assign(locationAction.href);
        }
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    var control = event.target.closest('.kjs-stepper a.minus_btn, .kjs-stepper a.plus_btn');
    if (!control || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    control.click();
  });

  function initializeCartPolish() {
    enhanceAllCarts();
    if (typeof window.MutationObserver === 'function') {
      new MutationObserver(function (mutations) {
        var index;
        for (index = 0; index < mutations.length; index += 1) {
          if (isCartMutation(mutations[index])) {
            scheduleEnhancement();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCartPolish);
  } else {
    initializeCartPolish();
  }

  document.addEventListener('shopify:section:load', scheduleEnhancement);
  window.addEventListener('pageshow', restoreReceiveMethods);
}());

